import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getNativeSlideStyles = (props, isLargeScreen) => {
  var alignment = props.alignment,
    heightConfig = props.heightConfig;
  return StyleSheet.create({
    nativeSlideBackground: Object.assign({}, heightConfig && {
      minHeight: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    }),
    nativeSlideContent: {
      paddingTop: isLargeScreen ? tokens.spacing.SPACING_36 : tokens.spacing.SPACING_20,
      alignItems: alignment === 'center' ? 'center' : 'flex-start',
      justifyContent: 'center',
      textAlign: alignment === 'center' ? 'center' : 'left'
    },
    nativeSlideLogo: {
      height: 20,
      width: 60,
      marginBottom: isLargeScreen ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_4,
      resizeMode: 'contain'
    },
    nativeSlideTitle: {
      marginBottom: isLargeScreen ? tokens.spacing.SPACING_12 : tokens.spacing.SPACING_8,
      width: alignment === 'center' ? '100%' : '60%',
      justifyContent: alignment === 'center' ? 'center' : 'flex-start'
    },
    nativeSlideSubtitle: {
      marginBottom: isLargeScreen ? tokens.spacing.SPACING_20 : tokens.spacing.SPACING_14,
      width: alignment === 'center' ? '100%' : '60%'
    },
    nativeSlideButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: isLargeScreen ? tokens.spacing.SPACING_22 : tokens.spacing.SPACING_16
    },
    nativeSlidePrimaryCta: {
      marginRight: tokens.spacing.SPACING_12
    },
    nativeSlideUspContainer: {
      marginBottom: isLargeScreen ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_14
    },
    nativeSlideUspItem: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    nativeSlideUspItemGap: {
      marginBottom: tokens.spacing.SPACING_4
    },
    alignCenter: {
      alignItems: 'center'
    }
  });
};